import React from 'react';
import cx from 'classnames';

const Paragraph = ({ type = 'text', color = 'primary', children, classes }) => {
  return (
    <p className={cx(classes.paragraph, classes[type], classes[`${color}Color`])}>{children}</p>
  );
};
export default Paragraph;
